import gql from 'graphql-tag';

import { ClaimViewFields } from '../fragments/claim';

export const ProcessOverrideClaim = gql`
  mutation ProcessOverrideClaim($input: GSTProcessOverrideClaimRequestInput!) {
    processOverrideClaim(input: $input) {
      result
      errorCode
      reasons
      claim {
        ...ClaimViewFields
      }
    }
  }
  ${ClaimViewFields}
`;
